module.exports = __webpack_public_path__ + "static/media/img105.2ae22309.jpg";